export type QueuePositionRecord = {
  doctor_id?: string;
  position?: number | string | null;
  user_order_in_queue?: number | string | null;
};

function positiveQueuePosition(record: QueuePositionRecord): number {
  const value = Number(record.user_order_in_queue ?? record.position ?? 0);
  return Number.isFinite(value) && value > 0 ? value : 0;
}

export function getNextDoctorQueuePosition(
  records: QueuePositionRecord[],
  doctorId: string
): number {
  const maxPosition = records.reduce((max, record) => {
    if (record.doctor_id !== doctorId) return max;
    return Math.max(max, positiveQueuePosition(record));
  }, 0);

  return maxPosition + 1;
}

export function getDisplayedQueuePosition(
  record: QueuePositionRecord,
  fallbackIndex: number
): number {
  return positiveQueuePosition(record) || fallbackIndex + 1;
}
